<template>
  <div class="card-container">
    <!-- <div v-if="duringSubmit" class="loading">
      <Loading />
    </div> -->
    <card class="card-login card-white">
      <Header pageTitle="Partner Nation Registration"></Header>
      <hr />
      <div class="text-left black">
        <strong>
          <ul>
            <li>Minimum password length 15 characters.</li>
            <li>
              Password must include at least 1:
              <br />Uppercase, Lowercase, Number, and Special Character
            </li>
            <li>
              Allowed Special Characters (! @ # $ % ^ & * ( ) _ + = - [ ] / ?)
            </li>
          </ul>
        </strong>

        <div><span class="color_red">*</span> Required field</div>
      </div>
      <fieldset>
        <legend>Invitation Information</legend>
        <label for="inviterEmail">Inviter's Email:</label>
        <base-input
          id="inviterEmail"
          v-validate="'required|email'"
          leftLabel="*"
          leftLabelColor="#C00000"
          v-model.trim="inviterEmail"
          name="inviterEmail"
          placeholder="Inviter's Email"
          addon-left-icon="tim-icons icon-email-85"
        ></base-input>
        <span v-show="errors.has('inviterEmail')" class="error">
          Please use a valid email
        </span>
        <br />
        <label for="pin">Pin:</label>
        <base-input
          id="pin"
          v-validate="{ required: true, max: 5, regex: /^[0-9]*$/ }"
          leftLabel="*"
          leftLabelColor="#C00000"
          :error="getError('pin')"
          v-model="pin"
          name="pin"
          data-vv-as="pin"
          ref="pin"
          type="number"
          placeholder="Pin"
          addon-left-icon="tim-icons icon-lock-circle"
        ></base-input>
      </fieldset>
      <fieldset>
        <legend>Basic Information</legend>
        <div class="row">
          <div class="col-md-6">
            <label for="FirstName">First Name:</label>
            <base-input
              id="FirstName"
              v-validate="'required'"
              leftLabel="*"
              leftLabelColor="#C00000"
              :error="getError('firstName')"
              v-model="firstName"
              name="firstName"
              data-vv-as="First Name"
              type="text"
              placeholder="First name"
              addon-left-icon="tim-icons icon-single-02"
            ></base-input>
          </div>
          <div class="col-md-6">
            <label for="LastName">Last Name:</label>
            <base-input
              id="LastName"
              v-validate="'required'"
              leftLabel="*"
              leftLabelColor="#C00000"
              :error="getError('lastName')"
              v-model="lastName"
              name="lastName"
              data-vv-as="Last Name"
              type="text"
              placeholder="Last name"
              addon-left-icon="tim-icons icon-single-02"
            ></base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="Title">Title:</label>
            <base-input
              id="Title"
              leftLabel="*"
              leftLabelColor="transparent"
              :error="getError('title')"
              v-model="title"
              name="title"
              type="text"
              placeholder="Title"
              addon-left-icon="tim-icons icon-badge"
            ></base-input>
          </div>
          <div class="col-md-6">
            <label for="PhoneNumber">Phone Number:</label>
            <div class="phone-field">
              <base-phone-input
                id="PhoneNumber"
                v-validate="{
                  required: false,
                  numeric: false,
                  regex: /^(?!.{21,24})[\(\)0-9]{7,21}$/,
                }"
                leftLabelColor="red"
                :error="getError('phoneNumber')"
                v-model="phoneNumberTemp"
                name="phoneNumber"
                data-vv-as="Phone Number"
                leftLabel="*"
                numeric="true"
                type="text"
                placeholder="(xxx)xxxxxxxxx"
              >
                <template v-slot:vcd-input>
                  <vue-country-dropdown
                    @onSelect="onSelect"
                    :preferredCountries="['US']"
                    :disabledFetchingCountry="true"
                    :defaultCountryByAreaCode="1"
                    :immediateCallSelectEvent="true"
                    :enabledFlags="true"
                    :enabledCountryCode="true"
                    :showNameInput="false"
                    :defaultCountry="'US'"
                    :showNotSelectedOption="false"
                    :onlyCountries="countryTwoCharacterCodes"
                  >
                  </vue-country-dropdown>
                </template>
              </base-phone-input>
            </div>
          </div>
        </div>
        <label for="Email">Email:</label>
        <base-input
          id="Email"
          v-validate="'required|email'"
          leftLabel="*"
          leftLabelColor="#C00000"
          v-model.trim="email"
          name="email"
          placeholder="Email"
          addon-left-icon="tim-icons icon-email-85"
        ></base-input>
        <span v-show="errors.has('email')" class="error">
          Please use a valid email
        </span>
        <br />
        <label for="password">Password:</label>
        <base-input
          id="password"
          v-validate="{
            required: true,
            regex: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%^&*()_+\=\-\[\]/?]).{8,}$/ 
          }"
          leftLabel="*"
          leftLabelColor="#C00000"
          v-model="password"
          name="password"
          data-vv-as="password"
          ref="password"
          type="password"
          placeholder="Password"
          addon-left-icon="tim-icons icon-lock-circle"
        >
        </base-input>
        <span
          class="error"
          v-for="(message, index) in passwordErrors.slice(0, 1)"
          :key="index"
          >{{
            `${getError("password") ? getError("password") : message}`
          }}</span
        >
        <br />

        <label for="confirmPassword">Confirm Password:</label>
        <base-input
          id="confirmPassword"
          v-validate="'required|confirmed:password'"
          leftLabel="*"
          leftLabelColor="#C00000"
          :error="getError('confirmPassword')"
          v-model="confirmPassword"
          data-vv-as="confirm password"
          name="confirmPassword"
          type="password"
          placeholder="Confirm password"
          addon-left-icon="tim-icons icon-lock-circle"
        ></base-input>
      </fieldset>

      <fieldset>
        <legend>Account Information</legend>
        <label for="Organization">Country:</label>
        <base-input
          :disabled="true"
          v-model="countryLabel"
          :error="getError('organization')"
          aria-label="Country"
        >
        </base-input>
      </fieldset>
      <fieldset>
        <register-files
          v-bind:initialDocumentArr="requiredDocmentTypes"
          v-bind:submittedTypes="submittedTypes"
        >
        </register-files>
      </fieldset>
      <fieldset>
        <user-upload
          v-on:userFileUpload="handleFileUpload"
          v-on:fileDelete="handleFileDelete"
          ref="uploadModal"
        ></user-upload>
      </fieldset>
      <br />

      <div class="button_grid">
        <router-link
          class="button grid_center_item"
          to="/Login"
          v-b-popover.hover.bottom="
            'Login to AGATRS using your username/password or using your CAC.'
          "
        >
          Already have an account?
        </router-link>
        <base-button
          @click="submit"
          :disabled="isDisabled"
          class="btn grid_center_item"
          type="primary"
          v-b-popover.hover.bottom="'Register for AGATRS!'"
        >
          <i class="tim-icons icon-send"></i>Request AGATRS Access
        </base-button>
      </div>
    </card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Header from "@/components/App/Header";
import Treeselect from "@riophae/vue-treeselect";
import swal from "sweetalert2";
import axios from "@/axios";
import { Select, Option, Divider, Checkbox } from "element-ui";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Util from "@/util/util";
import Utility from "@/mixins/utility/utility";
import Loading from "src/components/LoadingPanel";
import UserUpload from "../components/UserFilesUpload";
import RegisterFiles from "../components/RegisterDocumentList";
import VueCountryDropdown from "vue-country-dropdown";
import BasePhoneInput from "../components/Inputs/BasePhoneInput.vue";
import { keys } from "d3";

export default {
  name: "RegisterPartnerNation",
  components: {
    UserUpload,
    Header,
    [Select.name]: Select,
    [Option.name]: Option,
    [Divider.name]: Divider,
    [Checkbox.name]: Checkbox,
    Treeselect,
    Loading,
    RegisterFiles,
    VueCountryDropdown,
    BasePhoneInput,
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      title: "",
      phoneNumber: "",
      phoneNumberTemp: "",
      //   emailInformation: true,
      email: "",
      inviterEmail: "",
      pin: "",
      password: "",
      confirmPassword: "",
      organizationId: 0,
      approverId: null,
      registerErrorMessage: "",
      savingDocument: false,
      file: null,
      file2: null,
      remark: null,
      disabled: false,
      approverIdList: [],
      authorizedAs: [],
      countryLabel: "",
      duringSubmit: false,
      files: [],
      submittedTypes: [],
      requiredDocmentTypes: [],
    };
  },
  mixins: [Utility],
  mounted() {
    this.getPartnerNationOrganizations();
    this.getSponsorUsers();
    this.getcountryId();
    this.requiredDocmentTypes.push({
      name: "TRAINING CERTIFIED",
      added: false,
    });
    this.requiredDocmentTypes.push({
      name: "APPOINTMENT MEMO",
      added: false,
    });
    const dict = {
      custom: {
        password: {
          regex: this.passwordErrors,
          required: "Password is Required",
        },
        phoneNumber: {
          required: "Phone Number is required",
          regex: "Please enter at least 10 digits",
        },
        firstName: {
          required: "First Name is required"
        },
        lastName: {
          required: "Last Name is required"
        }
      },
    };
    this.$validator.localize("en", dict);
    this.getAllCountryTwoCharacterCode(false);
  },
  computed: {
    ...mapGetters({
      partnerNationOrganizations: "organization/partnerNationOrganizations",
      sponsorUsers: "users/sponsorUsers",
      countryTwoCharacterCodes: "countries/countryTwoCharacterCodes",
    }),
   passwordErrors() {
      const errors = [];
      if (this.password.length < 15) {
        errors.push('Password should contain at least 15 characters.')
      }
      if (!/[A-Z]/.test(this.password)) {
        errors.push('Password should contain at least 1 upper case letter.')
      }
      if (!/[a-z]/.test(this.password)) {
        errors.push('Password should contain at least 1 lower case letter.')
      }
      if (! /\d/.test(this.password)) {
        errors.push('Password should contain at least 1 number.')
      }
     const regex = /[!@#$%^&*()_+\=\-\[\]\/\?,]/;
      if (!regex.test(this.password)) {
        // If the password does not contain a special character, add an error message
        errors
          .push("Password should contain at least 1 special character. !@#$%^&*()_+=-[]/?")
      }
      return errors;
    },
    isDisabled() {
      return this.disabled;
    },
    authorizedAsLogistics() {
      return this.authorizedAs.includes("Logistics");
    },
    authorizedAsFinance() {
      return this.authorizedAs.includes("Finance");
    },
  },
  methods: {
    ...mapActions({
      getPartnerNationOrganizations:
        "organization/getPartnerNationOrganizations",
      registerPartnerNation: "authentication/registerPartnerNation",
      getSponsorUsers: "users/getSponsorUsers",
      register: "authentication/register",
      getAllCountryTwoCharacterCode: "countries/getAllCountryTwoCharacterCode",
    }),
    onSelect(data) {
      this.selectedCountryCode = data["dialCode"];
    },
    getError(fieldName) {
      return Util.makeTextSentenceLowerCase(this.errors.first(fieldName));
    },
    async getcountryId() {
      await axios
        .get(`/api/countries/id/${this.$route.params.countryId}`)
        .then((response) => {
          this.countryLabel = response.data.name;
        });
    },
    validate() {
      this.$validator.validateAll().then((isValid) => {
        this.$emit("on-submit", this.registerForm, isValid);
      });
    },
    onCancelClicked() {
      this.$router.push({
        name: "Login",
      });
    },
    handleFileDelete() {
      // update submittedTypes based on UserUpload's current state
      this.submittedTypes = this.$refs["uploadModal"].getFileTypes();
      // re-check required documents here
      this.updateRequiredDocumentStatus();
    },
    handleFileUpload(processedDocument) {
      // 'processedDocument' is the payload from UserUpload
      // The 'processedDocument' contains:
      // {
      //   file: FileObject,
      //   type: { id: number, name: string }, // Full type object
      //   remarks: string,
      //   id: clientSideId
      // }

      if (!processedDocument || !processedDocument.file) {
        this.$toast.error(
          "File upload failed: No file data received by RegisterPartnerNation."
        );
        console.error(
          "RegisterPartnerNation.vue - handleFileUpload: processedDocument.file is null or undefined.",
          processedDocument
        );
        return;
      }

      // Optional: Secondary validation
      const supportedTypesRegex = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
      if (
        !Util.isSupportedFile(processedDocument.file.name, supportedTypesRegex)
      ) {
        //this.$toast.error("Invalid File Type (caught in RegisterPartnerNation.vue)!");
        return;
      }

      // UserUpload has ALREADY added this file to its internal list and processed it.
      // This component just needs to update its 'submittedTypes'.
      this.submittedTypes = this.$refs["uploadModal"].getFileTypes();

      // Update the status of required documents
      this.updateRequiredDocumentStatus();
    },
    updateRequiredDocumentStatus() {
      if (this.requiredDocmentTypes && this.submittedTypes) {
        this.requiredDocmentTypes.forEach((reqDoc) => {
          reqDoc.added = this.submittedTypes.includes(reqDoc.name);
        });
      }
    },
    showLoadingSweetAlert(message) {
      new swal({
        position: "top-end",
        icon: "warning",
        title: "Please Wait Patiently",
        html: message,
        timer: 10000,
        showConfirmButton: false,
      });
    },
    async submit() {
      // get phone number formatted to only numbers
      var phone = this.selectedCountryCode + this.phoneNumberTemp;
      this.phoneNumber = "";
      for (var i = 0; i < phone.length; i++) {
        if (/^\d+$/.test(phone[i])) {
          this.phoneNumber += phone[i];
        }
      }
      let files = this.$refs["uploadModal"].getFiles();
      let ctx = this;
      this.savingDocument = true;

      // US register page doesn't use this
      // this.showLoadingSweetAlert(
      //   "Your document is uploading.<br><br>This message will disappear automatically in 10 seconds."
      // );
      // let isValid = await ctx.$validator.validateAll();
     
        // check the file
        if (this.submittedTypes.length === 0) {
          this.$toast.error("Required documents must be added");
          return;
        }
        // check if all requried file types have uploaded
        let missingFileTypes = [];
        for (let i = 0; i < this.requiredDocmentTypes.length; i++) {
          let f = this.requiredDocmentTypes[i];
          let r = this.submittedTypes.find((d) => d === f.name);
          if (r === undefined) {
            missingFileTypes.push(f.name);
          }
        }
        if (missingFileTypes.length > 0) {
          this.$toast.error(`Missing file type ${missingFileTypes.join(",")}`);
          return;
        }
        ctx.$loaderApp.addRequest();
        ctx.disabled = true;
        let formData = new FormData();

        // get phone number formatted to only numbers
        var phone = this.selectedCountryCode + this.phoneNumberTemp;
        this.phoneNumber = "";
        for (var i = 0; i < phone.length; i++) {
          if (/^\d+$/.test(phone[i])) {
            this.phoneNumber += phone[i];
          }
        }

         if (this.phoneNumberTemp.length < 10) {
        this.$toast.error(`Please enter at least 10 digits`);
          this.$loaderApp.completeRequest();

        return;
      }
        // add files
        let f = files.map((a) => a.file);
        for (let i = 0; i < f.length; i++) {
          formData.append("iFiles.iFiles", f[i]);
        }

        for (let i = 0; i < this.submittedTypes.length; i++) {
          formData.append("iFiles.fileTypes", this.submittedTypes[i]);
        }
        formData.append("firstName", ctx.firstName);
        formData.append("lastName", ctx.lastName);
        formData.append("title", ctx.title);
        formData.append("phoneNumber", ctx.phoneNumber);
        formData.append("email", ctx.email);
        formData.append("password", ctx.password);
        formData.append("isNotPartnerNation", false);
        formData.append("confirmPassword", ctx.confirmPassword);
        formData.append("organizationId", ctx.organizationId);
        formData.append("approverId", ctx.approverId);
        formData.append("pin", ctx.pin);
        formData.append("inviterEmail", ctx.inviterEmail);
        formData.append("CountryId", this.$route.params.countryId);
        this.savingDocument = false;
        try {
          await ctx.registerPartnerNation(formData);
          ctx.$loaderApp.completeRequest();
          ctx.disabled = false;
          //swal.close();
          ctx.$router.replace({
            name: "RegisterConfirmation",
            query: { user: "PartnerNation" },
          });
        } catch (err) {
          ctx.disabled = false;
          ctx.$loaderApp.completeRequest();
          //swal.close();
        }
      
    },
  },
};
</script>

<style lang="scss" scoped>
.el_date input,
.el_date .el-input__inner,
input,
.input-group-text,
.vue-treeselect__control,
.vs__dropdown-toggle {
  border-left: none !important;
  border-top: none !important;
  border-right: none !important;
  border-radius: 0 !important;
  line-height: 2 !important;
}

.input-group-text {
  padding-right: 5px !important;
}

.form-group input[type="file"] {
  opacity: inherit;
  position: inherit;
  top: inherit;
  right: inherit;
  bottom: inherit;
  left: inherit;
  width: inherit;
  height: inherit;
  z-index: inherit;
}

.loading {
  position: absolute;
  width: inherit;
  height: auto;
  background-color: lightblue;
}
</style>
